export default "__VITE_ASSET__C4UQOa$g__"